import { useQuery } from '@tanstack/react-query';
import { SelectPicker } from 'rsuite';
import { SelectPickerProps } from 'rsuite/lib/SelectPicker';
import { getCampaignTypes } from '../../services';
import styles from './CampaignTypeSelect.module.scss';

export type TCampaignType = {
  value: string;
  label: string;
  order: number;
  id: number;
};

interface ICampaignTypeSelectProps extends SelectPickerProps {
  item: TCampaignType;
  onSelect: (value: TCampaignType) => void;
}

export const CampaignTypeSelect = ({ item, onSelect, ...props }: ICampaignTypeSelectProps) => {
  const { data } = useQuery<TCampaignType[]>({
    queryKey: ['campaignTypes'],
    queryFn: getCampaignTypes,
  });

  const findItem = data?.find(type => type?.order?.toString() === item?.order?.toString());

  return (
    <div className={styles.container}>
      <SelectPicker
        {...props}
        value={findItem?.value}
        onSelect={(_value: string, item: TCampaignType) => onSelect(item)}
        data={data || []}
        renderMenuItem={(_value, item: TCampaignType) => (
          <div className={styles['render-item']}>
            <span className={styles['order']}>#{item.order}</span>
            <span className={styles['label']}>{item.label}</span>
          </div>
        )}
        renderValue={(_value, item: TCampaignType) => (
          <div className={styles['render-item']}>
            <span className={styles['order']}>#{item.order}</span>
            <span className={styles['label']}>{item.label}</span>
          </div>
        )}
      />
    </div>
  );
};
